/* iBrushy 14/10 «Rituale» (staging prototype, code 1C·2B·3A; 7B: every market + face): behaviour of the body offer, root .ibb--rit
   (snippets/ib-offer-body.liquid, ritual branch only), and the face offer tabs, root .ibf--rit (snippets/ib-offer-face-brush.liquid). Kit state stays in assets/ib-offer.js: the tabs are its tier labels,
   radio change -> selectBar -> 'ib:offer:change'; stage, chip and indicator follow .ib-offer__bar--selected in CSS.
   This file adds:
   - 3A: «Cosa riceverai» crossfade + container height animation on ib:offer:change (WAAPI 300ms, none on reduced motion).
   - 2B: fragrance slot -> native <dialog> sheet. A pick writes EVERY select[data-ib-prop] of the bundle ('' = Vanilla,
     'Ocean'; the kit guard reads /ocean/i) and dispatches a bubbling change on each, so ib-offer.js updateCreamRow swaps
     the cream row. Root data-ibr-scent drives the stage, slot name and jar in CSS. The fragrance is shared by all kit lists,
     so it persists across kit switches. */
(() => {
  if (window.ibRitual) return;
  window.ibRitual = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  // face offer root .ibf--rit (quiz 7B): tabs only, so of the handlers below just the .ibr--kbd ring does something there
  const rit = (el) => (el && el.closest ? el.closest('.ibb--rit,.ibf--rit') : null);

  // mirror a fragrance on the root and the sheet radios; fire = also write every select and notify ib-offer.js
  function scent(root, v, fire) {
    root.dataset.ibrScent = v ? 'ocean' : 'vanilla';
    if (v) root.classList.add('ibr--warm'); // ocean stage files exist in layout (lazy-load) from now on
    for (const r of root.querySelectorAll('.ibr__sheet input[type="radio"]')) r.checked = r.value === v;
    if (!fire) return;
    for (const s of root.querySelectorAll('select[data-ib-prop]')) {
      s.value = v;
      s.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // 3A: the outgoing list stays on top (absolute, .ibr-out) and fades out, the incoming one fades in, the box animates its height
  function lists(root) {
    const box = root.querySelector('.ibr__lists');
    const next = box && box.querySelector(':scope > [data-ib-list]:not([hidden])');
    const prev = root.ibrList;
    root.ibrList = next;
    if (!next || !prev || prev === next || reduce.matches) return;
    const run = (root.ibrAnims || []).filter((a) => a.playState === 'running');
    let h0 = box.offsetHeight; // mid-animation: the animated height
    (root.ibrAnims || []).forEach((a) => a.cancel());
    for (const l of box.querySelectorAll('.ibr-out')) l.classList.remove('ibr-out');
    prev.classList.add('ibr-out');
    if (!run.length) h0 = prev.offsetHeight; // at rest the box already has the new list's height
    const o = { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)' };
    box.style.overflow = 'hidden';
    const h = box.animate({ height: [h0 + 'px', next.offsetHeight + 'px'] }, o);
    const fin = prev.animate({ opacity: [1, 0] }, { ...o, fill: 'forwards' });
    h.onfinish = () => { box.style.overflow = ''; };
    fin.onfinish = () => { prev.classList.remove('ibr-out'); fin.cancel(); };
    root.ibrAnims = [h, fin, next.animate({ opacity: [0, 1] }, o)];
  }

  document.addEventListener('ib:offer:change', (e) => {
    const root = rit(e.target);
    if (root) lists(root);
  });

  document.addEventListener('change', (e) => {
    const t = e.target, root = rit(t);
    if (!root) return;
    if (t.matches('.ibr__sheet input[type="radio"]')) scent(root, t.value, true);
    else if (t.matches('select[data-ib-prop]')) scent(root, t.value, false);
  });

  // 2B sheet: slot opens it; X, Conferma and a backdrop click close it (Esc is native); the slot gets focus back on close
  document.addEventListener('click', (e) => {
    const t = e.target, root = rit(t);
    const dlg = root && root.querySelector('.ibr__sheet');
    if (!dlg) return;
    const slot = t.closest('.ibr__slot');
    if (slot) {
      dlg.ibrOpener = slot;
      root.classList.add('ibr--warm');
      if (!dlg.open) dlg.showModal();
      const on = dlg.querySelector('input:checked');
      if (on) on.focus();
    } else if (t === dlg || t.closest('[data-ibr-close]')) dlg.close();
  });

  // the sheet sits inside the product form: Enter on a sheet radio would submit it (add to cart), so Enter = confirm
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('.ibb--rit .ibr__sheet input')) return;
    e.preventDefault();
    e.target.closest('dialog').close();
  });

  // WebKit drops :focus-visible on a radio reached with the arrow keys: .ibr--kbd keeps the tab ring while the keyboard drives
  document.addEventListener('keydown', (e) => { const r = rit(e.target); if (r) r.classList.add('ibr--kbd'); }, true);
  document.addEventListener('pointerdown', (e) => { const r = rit(e.target); if (r) r.classList.remove('ibr--kbd'); }, true);

  document.addEventListener('close', (e) => {
    const d = e.target;
    if (d.matches && d.matches('.ibb--rit .ibr__sheet') && d.ibrOpener) d.ibrOpener.focus({ preventScroll: true });
  }, true);

  // restored form state (reload): any select on Ocean -> every select, cream row and the stage on Ocean
  function init() {
    for (const root of document.querySelectorAll('.ibb--rit')) {
      root.ibrList = root.querySelector('.ibr__lists > [data-ib-list]:not([hidden])');
      const ocean = [...root.querySelectorAll('select[data-ib-prop]')].some((s) => s.value === 'Ocean');
      scent(root, ocean ? 'Ocean' : '', ocean);
    }
  }
  // ib-offer.js (deferred, later in the page) must listen before a restored Ocean is re-dispatched
  if (window.ibOffer || document.readyState === 'complete') init();
  else addEventListener('DOMContentLoaded', init);
})();
